import { Navigate, useParams } from '@tanstack/react-router';
import { CollectionImportingState } from '@/features/collections';
import { importIsInvalid } from '@/services/db/collection/entity';
import { useCollection } from '@/services/db/collection/queries';
import { useWorkspaceIdFromCurrentUrl } from '@/services/router/use-workspace-id';
import { CollectionDetailPageShell } from './components/collection-detail-page-shell';

/**
 * Redirects during render rather than from an effect, so a finished import never paints the
 * "Importing" spinner on its way out. The detail query polls while importing, so landing
 * here and watching the import end — successfully or not — is the normal path.
 */
function ImportingBody() {
  const { collectionId } = useParams({ strict: false });
  const workspaceId = useWorkspaceIdFromCurrentUrl() ?? 0;
  const { data: collection } = useCollection({ id: collectionId ?? '' });

  if (collection.importing) {
    return <CollectionImportingState />;
  }

  // A first import that produced no rows has nothing to show on the data route, so it goes
  // back to the list — the same destination the bare detail route picks for that state.
  if (importIsInvalid(collection)) {
    return <Navigate to="/workspaces/$workspaceId/collections" params={{ workspaceId }} replace={true} />;
  }

  return (
    <Navigate
      to="/workspaces/$workspaceId/collections/$collectionId/data"
      params={{ workspaceId, collectionId: collection.id }}
      replace={true}
    />
  );
}

export default function ImportingPage() {
  return (
    <CollectionDetailPageShell titleSuffix="importing">
      <ImportingBody />
    </CollectionDetailPageShell>
  );
}
